import React from "react";
import contentfulImage, {ContentfulImageSource} from "@/libs/contentful/helper/ContentfulImage";
import {AssetFields} from "contentful";

export interface ImageRenderer {
    image: AssetFields
    className?: string|undefined
    width?: number|undefined
    height?: number|undefined
}

const ImageRenderer: React.FC<ImageRenderer> = ({image, className, width, height}) => {
    if(image && image.file?.contentType && (image.file.contentType === 'image/png' || image.file.contentType === 'image/jpeg')
        || image.file?.contentType === 'image/svg+xml'){

        const altText: string = (image.description || '').toString();
        const imageUrl: string = contentfulImage(image as ContentfulImageSource, {
            quality: 60,
            format: "webp",
            width: 1560,
            height: 780
        })

        let setWidth = width === undefined ? 200 : width
        let setHeight = height === undefined ? 200 : height

        if (width === undefined && image.file && image.file.details && image.file.details.image) {
            setWidth = image.file.details.image.width
        }

        if (height === undefined && image.file && image.file.details && image.file.details.image) {
            setHeight = image.file.details.image.height
        }

        return (
            <picture className={'w-full h-full flex ' + className}>
                <source media="(min-width:991px)" srcSet={imageUrl}/>
                <img src={imageUrl} className={'w-fill h-full object-cover'} alt={altText} width={setWidth}
                     height={setHeight} loading="lazy"/>
            </picture>
        )
    } else {
        return;
    }
};

export default ImageRenderer;